function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1.33759 10.02C1.19726 9.86759 1.07533 9.73018 0.973079 9.61207C1.07533 9.49396 1.19726 9.35655 1.33759 9.20414C1.82543 8.67432 2.53111 7.9683 3.40094 7.26388C5.16083 5.83866 7.49384 4.5 10 4.5C12.5062 4.5 14.8392 5.83866 16.5991 7.26388C17.4689 7.9683 18.1746 8.67432 18.6624 9.20414C18.8027 9.35655 18.9247 9.49396 19.0269 9.61207C18.9247 9.73018 18.8027 9.86759 18.6624 10.02C18.1746 10.5498 17.4689 11.2558 16.5991 11.9603C14.8392 13.3855 12.5062 14.7241 10 14.7241C7.49384 14.7241 5.16083 13.3855 3.40094 11.9603C2.53111 11.2558 1.82543 10.5498 1.33759 10.02Z",
  stroke: "#627080",
  strokeWidth: 1.5
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.99718 11.75C12.2063 11.75 13.9972 9.95914 13.9972 7.75C13.9972 5.54086 12.2063 3.75 9.99718 3.75C7.78804 3.75 5.99718 5.54086 5.99718 7.75C5.99718 9.95914 7.78804 11.75 9.99718 11.75ZM8.62432 8.57778C9.38609 8.57778 10.0036 7.96024 10.0036 7.19847C10.0036 6.4367 9.38609 5.81916 8.62432 5.81916C7.86255 5.81916 7.24501 6.4367 7.24501 7.19847C7.24501 7.96024 7.86255 8.57778 8.62432 8.57778Z",
  fill: "#627080"
});

const SvgEye = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEye, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Eye.ebe82e2f.svg";
export { ForwardRef as ReactComponent };